import React, { useState } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import Auth_Failures_Dist from './Auth_Failures_Dist';
import progressGif from "../../images/progress.gif";
import { useNavigate } from 'react-router-dom';

const Auth_Failures_Interface = ({ heading }) => {

  const [renderContent, setRenderContent] = useState(null);
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [loadingYears, setLoadingYears] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = () => {

    const month = document.getElementById('month').value;
    const year = document.getElementById('year').value;

    if (!month || month === '0') {
      alert('Please select Month');
      return;
    }
    if (!year || year === '0') {
      alert('Please select Year');
      return;
    }

    setSubmitting(true);
    setRenderContent(null);

    setTimeout(() => {

      setRenderContent(
        <Auth_Failures_Dist
          month={month}
          year={year}
          userRole={sessionStorage.getItem("user_role")}
          distCode={sessionStorage.getItem("dist_code")}
        />
      );

      setSubmitting(false);

    }, 3000);
  };

  return (
    <div className="wrapper row3">
      <div id="container">

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <table width="40%">
            <thead>
              <tr className="tableheader">
                <th colSpan={8}>{heading}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Month</td>
                <td><GetMonths onLoadingChange={setLoadingMonths} /></td>
                <td>Year</td>
                <td><GetYears onLoadingChange={setLoadingYears} /></td>
              </tr>
              <tr>
                <td colSpan={8} align="center">
                  <button
                    onClick={handleSubmit}
                    className="button button2"
                    disabled={loadingMonths || loadingYears || submitting}
                  >
                    Submit
                  </button>

                  <button
                    className="button button2"
                    onClick={() => navigate(-1) || navigate('/')}
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />

        {submitting && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <img src={progressGif} alt="Loading..." width="250" height="15" />
          </div>
        )}

        <div id="details1">{renderContent}</div>

      </div>
    </div>
  );
};

export default Auth_Failures_Interface;
